module.exports = __webpack_public_path__ + "img/75.2c7e7c4e.jpg";